/* Carousel arrows and the save heart.
   Arrows page by one screenful of cards; they appear only when the row overflows,
   and grey out at either end. Hearts are remembered in this browser only
   (localStorage, key melanin:saved): there is no account-backed wishlist yet. */
(() => {
  document.querySelectorAll('[data-carousel]').forEach((track) => {
    /* Phone progress line: fills as the row scrolls, full at the last card (2026-09-26). */
    const bar = track.parentElement.querySelector('[data-carousel-bar]');
    if (bar) {
      const fill = () => {
        const w = track.scrollWidth;
        bar.hidden = w - track.clientWidth <= 2;
        bar.style.setProperty('--p', Math.min(1, (track.scrollLeft + track.clientWidth) / w).toFixed(4));
      };
      track.addEventListener('scroll', fill, { passive: true });
      window.addEventListener('resize', fill);
      fill();
    }
    const nav = track.parentElement.querySelector('[data-carousel-nav]');
    if (!nav) return;
    const [prev, next] = nav.querySelectorAll('.carousel__btn');
    const sync = () => {
      const max = track.scrollWidth - track.clientWidth;
      nav.hidden = max <= 2;
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= max - 2;
    };
    /* One click turns the whole screenful (2026-09-28, Shalev: "all four change at once"). scrollBy moved ONE
       card: with scroll-snap a relative scroll stops at the next snap point in its direction. So the target is
       computed as whole cards (card + gap) x cards in view, and scrollTo lands on it exactly. */
    const page = (dir) => {
      const first = track.children[0];
      if (!first) return;
      const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      const unit = first.getBoundingClientRect().width + gap;
      const inView = Math.max(1, Math.round((track.clientWidth + gap) / unit));
      const at = Math.round(track.scrollLeft / unit);
      track.scrollTo({ left: (at + dir * inView) * unit, behavior: 'smooth' });
    };
    nav.addEventListener('click', (e) => {
      const b = e.target.closest('.carousel__btn');
      if (b) page(Number(b.dataset.dir));
    });
    track.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
        e.preventDefault();
        page(e.key === 'ArrowRight' ? 1 : -1);
      }
    });
    track.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    sync();
  });

  /* Reviews row on a phone: the same filling line as the Best Sellers carousel (2026-09-26). */
  const rvRow = document.querySelector('[data-rv-row]'), rvLine = document.querySelector('[data-rv-line]');
  if (rvRow && rvLine) {
    const fill = () => rvLine.style.setProperty('--p', Math.min(1, (rvRow.scrollLeft + rvRow.clientWidth) / rvRow.scrollWidth).toFixed(4));
    rvRow.addEventListener('scroll', fill, { passive: true }); window.addEventListener('resize', fill); fill();
  }

  /* Hearts (saved works): kept in this browser (localStorage melanin:saved). Delegated, so cards added later
     (the Saved page, 2026-09-27) work too. Every change announces 'melanin:saved' for the header count and
     the Saved page. */
  const KEY = 'melanin:saved';
  const read = () => { try { return new Set(JSON.parse(localStorage.getItem(KEY) || '[]')); } catch { return new Set(); } };
  const write = (s) => { try { localStorage.setItem(KEY, JSON.stringify([...s])); } catch { /* private mode */ } };
  const saved = read();
  const paint = () => {
    document.querySelectorAll('[data-save]').forEach((b) => b.setAttribute('aria-pressed', String(saved.has(b.dataset.save))));
    document.querySelectorAll('[data-saved-count]').forEach((el) => { el.textContent = saved.size ? `(${saved.size})` : ''; });
  };
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-save]');
    if (!b) return;
    const h = b.dataset.save;
    if (saved.has(h)) saved.delete(h); else saved.add(h);
    write(saved);
    paint();
    document.dispatchEvent(new CustomEvent('melanin:saved', { detail: { handle: h, saved: saved.has(h), all: [...saved] } }));
  });
  document.addEventListener('melanin:cards-added', paint);
  paint();

  /* The Product / Lifestyle switch was removed (Shalev 2026-09-26); clear any stored choice. */
  try { localStorage.removeItem('melanin:view'); } catch { /* private mode */ }
})();

/* Picture stepper on collection cards (product-card with slides: true; Shalev 2026-09-27, like Dior).
   The first picture comes with the page. The rest are built the first time the pointer enters the card, so a
   click is instant and a visitor who never hovers downloads nothing extra. Arrows step one picture; nothing
   moves by itself. The line under the picture fills step by step: 1/n, 2/n ... n/n. */
(() => {
  const initSteppers = () => document.querySelectorAll('.card__nav[data-slides]:not([data-ready])').forEach((nav) => {
    nav.dataset.ready = '1';
    const card = nav.closest('.card');
    const art = card && card.querySelector('.card__art');
    if (!art) return;
    const n = Number(nav.dataset.count) || 1;
    const prev = nav.querySelector('[data-slide="-1"]');
    const next = nav.querySelector('[data-slide="1"]');
    const fill = nav.querySelector('.card__steps i');
    let imgs = null;
    let i = 0;
    const build = () => {
      if (imgs) return;
      const first = art.querySelector('img');
      imgs = [first];
      nav.dataset.slides.split('~').forEach((pair, k) => {
        const [src, alt] = pair.split('|');
        if (!src) return;
        const im = document.createElement('img');
        im.className = 'card__slide';
        im.src = src;
        im.alt = alt || '';
        im.decoding = 'async';
        im.style.setProperty('--off', k + 1);
        art.appendChild(im);
        imgs.push(im);
      });
    };
    const show = () => {
      art.classList.add('is-stepping');
      imgs.forEach((im, k) => im.style.setProperty('--off', k - i));
      if (fill) fill.style.setProperty('--p', ((i + 1) / imgs.length).toFixed(4));
      if (prev) prev.disabled = i <= 0;
      if (next) next.disabled = i >= imgs.length - 1;
    };
    card.addEventListener('mouseenter', build, { once: true });
    /* Phone (Shalev 2026-09-27): a sideways swipe on the picture steps one picture; an up-down drag still scrolls
       the page (touch-action: pan-y on the picture), and a swipe never opens the product. */
    let x0 = 0, y0 = 0, swiped = false;
    art.addEventListener('touchstart', (e) => { const t = e.touches[0]; x0 = t.clientX; y0 = t.clientY; swiped = false; build(); }, { passive: true });
    const shelf = card.closest('.shelf__row');
    art.addEventListener('touchend', (e) => {
      if (shelf && shelf.scrollWidth > shelf.clientWidth + 1) return;
      const t = e.changedTouches[0]; const dx = t.clientX - x0; const dy = t.clientY - y0;
      if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy) * 1.2) return;
      swiped = true;
      i = Math.max(0, Math.min(imgs.length - 1, i + (dx < 0 ? 1 : -1)));
      show();
    }, { passive: true });
    card.addEventListener('click', (e) => { if (swiped) { e.preventDefault(); swiped = false; } }, true);
    nav.addEventListener('click', (e) => {
      const b = e.target.closest('[data-slide]');
      if (!b) return;
      e.preventDefault();
      build();
      i = Math.max(0, Math.min(imgs.length - 1, i + Number(b.dataset.slide)));
      show();
    });
    if (fill) fill.style.setProperty('--p', (1 / n).toFixed(4));
  });
  initSteppers();
  document.addEventListener('melanin:cards-added', initSteppers);
})();
